import {
    createSelector,
    createSlice,
} from '@reduxjs/toolkit'
import { DATE_FILTER } from '../constants/core'

const initialState = {
    filter: DATE_FILTER.WEEKLY,
    from: null,
    to: null
}

const datePickerSlice = createSlice({
    name: 'datePicker',
    initialState: initialState,
    reducers:{
        datePickerReset: (state, action) => {
            state.filter = DATE_FILTER.WEEKLY
            state.from = null
            state.to = null
        },
        datePickerSetRange: (state, action) => {
            const {from, to} = action.payload
            state.filter = DATE_FILTER.CUSTOM
            state.from = from
            state.to = to
        },
        datePickerSetFilter: (state, { payload: filter }) => {
            state.filter = filter
            state.from = null
            state.to = null
        }
    }
})

export const { datePickerReset, datePickerSetRange, datePickerSetFilter} = datePickerSlice.actions

export default datePickerSlice.reducer

export const selectDatePicker = createSelector(
    state => state.datePicker,
    datePicker => ({filter: datePicker.filter, from: datePicker.from, to: datePicker.to})
)